<template>
    <div class="main">
        <div id="app" style="position:relative;height:100%;display:flex;flex-direction:column;align-items:center;">
            <div v-if="appId==0||appId==1" style="position:relative;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;">
                <div class="header">
                    <span class="imge" @click.stop="showHome">
                        <img src="files/image/new/logo-m@2x.png" alt="">
                    </span>
                    <span class="select">
                        <template>
                            <el-select @change="handerChange" v-model="valueSelect" placeholder="请选择">
                                <el-option
                                    v-for="item in optionsSelect"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </span>
                </div>
                <div v-show="closeMenu&&optionsSelect&&optionsSelect[2]&&optionsSelect[2].id===valueSelect" class="menu-child" @click.stop="showMenu">
                    <span>{{closeMenu}}</span> <img src="files/image/new/child.png" alt="">
                    <!-- <i  class="el-icon-arrow-down"></i> -->
                </div>
                <div class="contain" v-if="valueSelect==='1111'">
                    <img src="files/image/new/bk@2x.png" alt="" class="img">
                </div>
                <div class="contain-second" :class="{'menu_show':closeMenu}" v-else-if="showWebsite">
                    <el-scrollbar style="height:100%;">
                        <div class="contain-second-item" v-if="(dataWebsite&&dataWebsite.content)||(dataWebsite&&dataWebsite.attachmentList&&dataWebsite.attachmentList.length>0)" v-loading="loading">
                            <div v-html="dataWebsite.content" class="content"></div>
                            <p v-if="dataWebsite&&dataWebsite.attachmentList&&dataWebsite.attachmentList.length>0">附件</p>
                            <div class="comm-file-logo-box">
                                <div v-for="(item,index) in dataWebsite.attachmentList" :key="item+index" class="comm-file-logo">
                                    <a :href="item.fileUrl" v-if="checkFileType(item.fileName)=='.pdf'" class="aimg">
                                        <img src="files/image/new/wj_pdf.png"> <span>{{item.fileName}}</span>
                                    </a>
                                    <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.docx'||checkFileType(item.fileName)=='.doc'" class="aimg">
                                        <img src="files/image/new/wj_word.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                    <a :href="item.fileUrl" v-else-if="checkFileType(item.fileName)=='.png'||checkFileType(item.fileName)=='.jpeg'||checkFileType(item.fileName)=='.jpg'">
                                        <img :src="item.fileUrl">
                                    </a>
                                    <a @click="openfile(item.fileUrl,item.fileName)" v-else-if="checkFileType(item.fileName)=='.txt'" class="aimg">
                                        <img src="files/image/new/sketch.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                    <a v-else :href="item.fileUrl" class="aimg"> <img src="files/image/new/sketch.png">
                                        <span>{{item.fileName.split('.')[0]}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="no-data" v-else-if="!dataWebsite&&!loading||!dataWebsite.content&&!loading&&!dataWebsite.attachmentList">
                            <img src="files/image/new/no-data@2x.png" alt=""> <span>暂无数据</span>
                        </div>

                    </el-scrollbar>
                </div>
                <div class="menu-second" v-show="!showWebsite&&optionsSelect&&optionsSelect[2]&&optionsSelect[2].id===valueSelect">
                    <el-scrollbar style="height:100%;">
                        <el-tree
                            v-show="!closeMenu"
                            class="tree"
                            accordion
                            node-key="id"
                            :expand-on-click-node="true"
                            ref="activityTree"
                            :props="orgProp"
                            :empty-text="!treeLoading?'暂无子目录':''"
                            v-loading="treeLoading"
                            lazy
                            :load="getWebsiteMenu"
                            :data="treeData"
                            :render-content="renderContent"
                            highlight-current
                        >
                        </el-tree>
                    </el-scrollbar>
                </div>
            </div>
            <div v-if="appId==2||appId==3" style="width:100%;height:70%;margin-top:15%;display:flex;flex-direction:column;justify-content:space-around;align-items:center">
                <div style="width:70%;">
                    <img style="width:100%;" src="files/image/obg-mobile-title.png"/>
                </div>
                <div style="width:25%;">
                    <img style="width:100%;" src="files/image/obg-mobile-logo.png"/>
                </div>
            </div>
            <!-- 微信提示 -->
            <div v-if="show_weixin_notice==1" @click="close_weixin_notice" style="position:absolute;top:0;width:100%;max-width:640px;height:100%;background:rgba(0,0,0,0.8);z-index:1000">
                <img src="files/image/weixin_notice.png" style="position:absolute;width:40%;top:30px;right:30px;"/>
            </div>
            <!-- 底部下载 -->
            <div v-show="device_type != ''&&(appId==0||appId==1)&&valueSelect==='1111'"
                style="position:fixed;z-index:999;bottom:0;width:100%;max-width:640px;height:60px;background:white"
            >
                <!--  andriod下载弹窗  -->
                <div v-if="device_type == 'android'" style="width:40%;height:10%;margin:0 auto;font-size:16px;">
                    <div @click="openDialogVisible" class="download-btn" style="width:100%">
                        <div class="item">
                            <span>立即下载</span>
                        </div>
                    </div>
                    <el-dialog
                        :append-to-body="true"
                        :close-on-press-escape="false"
                        :close-on-click-modal="false"
                        :show-close="false"
                        center
                        :modal="true"
                        :title="$t(`identityVerification`)"
                        :visible.sync="dialogVisible"
                        :before-close="cancel"
                        width="300px"
                        class="dialog"
                    >
                        <h3>{{title}}</h3>
                        <div v-if="checks" class="dialog_oa">
                            <el-input v-model="idValue" placeholder="请输入OA账号/工号/邮箱前缀"></el-input>
                        </div>
                        <div v-else class="dialog_code">
                            <el-form :model="phone_form" :rules="rules" ref="ruleForm">
                                <el-form-item prop="phone">
                                    <el-input class="phone_word" v-model="phone_form.phone" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <el-input class="code_word" placeholder="请输入验证码" v-model="phone_form.code"></el-input>
                                    <el-button type="text" v-show="codeShow" :disabled="!codeShow" class="code_btn" @click="sendCode">获取验证码</el-button>
                                    <el-button v-show="!codeShow" disabled class="code_btn1">已发送（{{codeCount}}s）</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <Vcode :show="isShowCode" @success="success" @close="close"/>
                        <el-button @click="changeCheck" class="btn_font" size="small" type="text">{{checks?'手机验证码匹配':'账号/工号匹配'}}</el-button>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="cancel" class="cancel-btn" size="small">取 消</el-button>
                            <el-button v-if='checks' class="color-btn" type="primary" :disabled="idValue==''" size="small" @click="identification">确认下载</el-button>
                            <el-button v-else type="primary" class="color-btn" :disabled="phone_form.phone==''&&phone_form.code==''" size="small" @click="checkCodeType">确认下载</el-button>
                        </span>
                    </el-dialog>
                    <div style="clear:both"></div>
                </div>

                <!--  IOS下载弹窗  -->
                <div v-if="device_type == 'ios'" style="width:40%;height:10%;margin:0 auto;font-size:16px;">
                    <div @click="download_ios" class="download-btn" style="width:100%">
                        <div class="item">
                            <span>立即下载</span>
                        </div>
                    </div>
                    <el-dialog
                        :append-to-body="true"
                        :close-on-press-escape="false"
                        :close-on-click-modal="false"
                        :show-close="false"
                        center
                        :modal="true"
                        :title="$t(`identityVerification`)"
                        :visible.sync="logVisible"
                        width="300px"
                        class="dialog"
                    >
                        <h3>{{$t('onlyTCL')}} </h3>
                        <div v-if="checks">
                            <el-form :model="form">
                                <el-form-item style="margin-bottom: 6px">
                                    <el-input size="mini" v-model="form.account" :placeholder="$t('oaPlaceholder')" autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-input
                                        size="mini"
                                        v-model="form.password"
                                        type="password"
                                        :placeholder="$t('pwdPlaceholder')"
                                        autocomplete="off"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-else class="dialog_code">
                            <el-form :model="phone_form" :rules="rules" ref="ruleForm">
                                <el-form-item prop="phone">
                                    <el-input class="phone_word" v-model="phone_form.phone" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <el-input class="code_word" placeholder="请输入验证码" v-model="phone_form.code"></el-input>
                                    <el-button type="text" v-show="codeShow" :disabled="!codeShow" class="code_btn" @click="sendCode">获取验证码</el-button>
                                    <el-button v-show="!codeShow" disabled class="code_btn1">已发送（{{codeCount}}s）</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <Vcode :show="isShowCode" @success="success" @close="close"/>
                        <el-button @click="changeCheck" class="btn_font" size="small" type="text">{{checks?'手机验证码匹配':'账号/工号匹配'}}</el-button>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="logVisible = false" class="cancel-btn" size="small">取 消</el-button>
                            <el-button v-if='checks' class="color-btn" type="button" :disabled="form.account===''&&form.password===''" @click.stop="submitLog">{{$t('iosLogin')}} </el-button>
                            <el-button v-else class="color-btn" type="button" :disabled="phone_form.phone==''&&phone_form.code==''" @click="checkCodeType">{{$t('iosLogin')}} </el-button>
                        </span>
                    </el-dialog>
                    <div style="clear:both"></div>
                </div>
            </div>

            <!--  登录  -->
            <div v-if="device_type != ''&&(appId==2||appId==3)" style="height:30%;max-width:640px;">
                <div v-if="device_type == 'android'" style="width:100%;">
                    <div @click="download_andriod" style="width:60%;margin:0 auto;">
                        <img style="width:100%;" src="files/image/obg-mobile-button.png" alt/>
                    </div>
                </div>
                <div v-if="device_type == 'ios'" style="width:100%;">
                    <div @click="download_ios" style="width:60%;margin:0 auto;">
                        <img style="width:100%;" src="files/image/obg-mobile-button.png" alt/>
                    </div>
                    <el-dialog
                        :append-to-body="true"
                        :close-on-press-escape="false"
                        :close-on-click-modal="false"
                        :show-close="false"
                        center
                        :modal="true"
                        :title="$t(`identityVerification`)"
                        :visible.sync="logVisible"
                        width="70%"
                    >
                        <h3>{{$t('onlyTCL')}} </h3>
                        <el-form :model="form">
                            <el-form-item>
                                <el-input v-model="form.account" :placeholder="$t('oaPlaceholder')" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input
                                    v-model="form.password"
                                    type="password"
                                    :placeholder="$t('pwdPlaceholder')"
                                    autocomplete="off"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="logVisible = false" class="cancel-btn" size="small">取 消</el-button>
                            <el-button size="small" class="color-btn" type="text" style="width:200px;color:#00B6FF;font-size:17px;" @click.stop="submitLog">{{$t('iosLogin')}} </el-button>
                        </span>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CryptoJS from "crypto";
    import {judge, setMeta} from "@/js/judge.js";
    import {Base64} from 'js-base64'
    //先导入pako
    import pako from 'pako'
    import Vcode from "vue-puzzle-vcode";

    export default {
        components: {
            Vcode
        },
        data() {
            const phoneValidate = (rule, value, callback) => {
                if (!value && value !== 0) {
                    return callback(new Error('手机号不能为空'))
                }
                if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
                    return callback(new Error('请填写正确的手机号码！'))
                } else {
                    callback()
                }
            }
            const codeValidate = (rule, value, callback) => {
                if (!this.isSendCode) {
                    if (!value && value !== 0) {
                        return callback(new Error('请输入验证码'))
                    }
                    // if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                    //   return callback(new Error('请填写正确的手机号码！'))
                    // } else {
                    //   callback()
                    // }
                } else {
                    callback()
                }
            }
            return {
                form: {
                    account: "",
                    password: "",
                    appId: this.dlUrl.iosDown
                },
                logVisible: false,
                show: false,
                device_type: "",
                show_weixin_notice: 0,
                andriod_href: '',
                appId: this.dlUrl.appId,
                ios_href: "itms-services://?action=download-manifest&url=",
                appleVerify: this.dlUrl.appleVerify,
                websiteDirectory: this.dlUrl.websiteDirectory,
                websiteContent: this.dlUrl.websiteContent,
                websiteContentZip: this.dlUrl.websiteContentZip,
                getDownloadVersion: this.dlUrl.getDownloadVersion,
                appIdCode: this.dlUrl.appIdCode,
                lang: this.dlUrl.lang,
                getCode: this.dlUrl.getCode,
                checkCode: this.dlUrl.checkCode,
                v1WebLogin: this.dlUrl.v1WebLogin,
                valueSelect: '1111',
                optionsSelect: [
                    {
                        id: '1111',
                        name: '下载'
                    },
                ],
                dataWebsite: {},
                pId: 0,
                mId: '',
                orgProp: {
                    children: 'children',
                    label: 'name',
                    value: 'code'
                },
                treeLoading: false,
                nodeObj: {},
                node_had: [], // 触发 tree 的 :load=loadNode 重复触发  动态更新tree
                resolve_had: [],
                treeData: [],
                showWebsite: false,
                showTree: false,
                fileData: [],
                loading: false,
                closeMenu: '',
                closeKey: '',
                dialogVisible: false,
                idValue: '',
                checks: true,
                phone_form: {
                    phone: '',
                    code: ''
                },
                codeShow: true,
                codeCount: '',
                codeTimer: null,
                isShowCode: false,
                isSendCode: false,
                title: '输入您的账号/工号，匹配对应版本',
                platform: 'Android',
                rules: {
                    phone: [
                        // { required: true, message: '请输入正整数', trigger: 'change' },
                        {validator: phoneValidate, trigger: 'blur'},
                    ],
                    code: [
                        {validator: codeValidate, trigger: 'blur'},
                    ]
                },
                iosLogin: false,
            };
        },
        watch: {
            filterText(val) {
                this.$refs.activityTree.filter(val);
            }
        },
        computed: {
            type() {
                return !this.file && !this.file.url ? '' : this.file.url.substr(this.file.url.lastIndexOf('.'), this.file.url.length) // 上传的文件后缀名
            }
        },
        mounted() {
            //设置meta数据
            setMeta();
            //判断PC
            this.judgePC();

            this.$nextTick(() => {
                this.getWebsiteDirectory()
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    // 在微信浏览器
                    this.logVisible = false;
                } else {
                    this.logVisible = true;
                }
                // var mySwiper = new Swiper(".swiper-container", {
                //   speed: 1000, //播放速度
                //   autoplay: {
                //     delay: 3000,
                //     disableOnInteraction: false
                //   },
                //   pagination: {
                //     el: ".swiper-pagination",
                //     type: "bullets"
                //   },
                //   effect: "fade" //动画效果
                // });
            });
            var that = this;
            // 计算图片演示区域高度 （减去底部导航）
            // eslint-disable-next-line no-undef
            $("#app").css("height", $(document).height());
            // $("#swiper-container").css("height", $(document).height() - 60);
            // 获取设备的型号，安卓orIOS
            // 获取请求头中的userAgent
            var u = navigator.userAgent;
            //是否是android浏览器
            var isAndroid = u.indexOf("Android") > -1;
            //是否是ios浏览器
            var isIos = !!u.match(/\Mac OS X/);
            // window.window.console.log('isAndroid',u.indexOf("Android") > -1)
            // window.window.console.log('isIos',!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/))
            var msg = "";
            if (isAndroid) {
                msg = "当前是android客户端";
                that.device_type = "android";
                that.show = true;
            } else if (isIos) {
                msg = "当前是ios客户端";
                that.device_type = "ios";
                that.show = true;
            }
            window.console.log('客户端:', msg)
        },
        methods: {
            //工号还是手机号验证切换
            changeCheck() {
                window.console.log('改变的', this.checks)
                this.checks = !this.checks
                this.title = this.checks ? '输入您的账号/工号，匹配对应版本' : '手机验证码匹配对应版本'
            },
            //判断是否PC
            judgePC() {
                window.window.console.log('===', judge())
                if (judge()) {
                    this.$router.push({path: "/"});
                }
            },
            //加密
            encryptByDES(message) {
                let key = "3de12d03";
                var keyHex = new Buffer(key);
                var iv = new Buffer([1, 2, 3, 4, 5, 6, 7, 8]);
                var cipher = CryptoJS.createCipheriv("des-cbc", keyHex, iv);
                cipher.setAutoPadding(true); // default true
                var ciph = cipher.update(message, "utf8", "base64");
                ciph += cipher.final("base64");
                return ciph;
            },
            decryptByDES(encrypt_text) {
                let key = "3de12d03";
                var keyHex = new Buffer(key);
                var iv = new Buffer([1, 2, 3, 4, 5, 6, 7, 8]);
                var decipher = CryptoJS.createDecipheriv("des-cbc", keyHex, iv);
                decipher.setAutoPadding(true);
                var txt = decipher.update(encrypt_text, "base64", "utf8");
                txt += decipher.final("utf8");
                return txt;
            },
            //发送验证码请求
            sendCode() {
                this.isSendCode = true
                this.$refs['ruleForm'].validate((valid) => {
                    window.console.log('valid', valid)
                    if (valid) {
                        let params = {
                            appId: this.appIdCode,
                            lang: this.lang === 'zh' ? 'zh_CN' : 'en_US',
                            phone: this.phone_form.phone
                        }
                        window.console.log('params:', params)
                        // eslint-disable-next-line no-undef
                        $.ajax({
                            //请求方式
                            type: "POST",
                            //请求的媒体类型
                            contentType: "application/x-www-form-urlencoded",
                            url: this.getCode,
                            //数据，json字符串
                            data: params,
                            //请求成功
                            success: res => {
                                if (res.code == 0) {
                                    this.isSendCode = false
                                    this.isShowCode = true
                                    this.logVisible = false
                                    this.dialogVisible = false
                                    window.console.log('获取验证码成功', res)
                                    this.$message.success(res.msg)
                                } else {
                                    this.$message.error(res.msg);
                                }
                            },
                            //请求失败，包含具体的错误信息
                            error: error => {
                                window.console.log('error:', error)
                                this.$message.error(error.msg);
                                this.isSendCode = false
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 用户通过了滑块验证
            success() {
                this.isShowCode = false; // 通过验证后，需要手动隐藏模态框
                this.logVisible = true
                this.dialogVisible = true
                const TIME_COUNT = 60;
                if (!this.codeTimer) {
                    this.codeCount = TIME_COUNT;
                    this.codeShow = false;
                    this.codeTimer = setInterval(() => {
                        if (this.codeCount > 0 && this.codeCount <= TIME_COUNT) {
                            this.codeCount--;
                        } else {
                            this.codeShow = true;
                            clearInterval(this.codeTimer);
                            this.codeTimer = null;
                        }
                    }, 1000)
                }
            },
            // 用户点击遮罩层，应该关闭模态框
            close() {
                this.isShowCode = false;
                this.dialogVisible = true
            },
            //验证验证码请求
            checkCodeType() {
                this.isSendCode = true
                this.$refs['ruleForm'].validate((valid) => {
                    window.console.log('valid', valid)
                    if (valid) {
                        let params = {
                            isPhone: this.checks ? 0 : 1,
                            appId: this.appIdCode,
                            lang: this.lang === 'zh' ? 'zh_CN' : 'en_US',
                            phone: this.phone_form.phone,
                            code: this.phone_form.code,
                            src: 1
                        }
                        window.console.log('params:', params)
                        // eslint-disable-next-line no-undef
                        $.ajax({
                            //请求方式
                            type: "POST",
                            //请求的媒体类型
                            contentType: "application/x-www-form-urlencoded",
                            url: this.checkCode,
                            //数据，json字符串
                            data: params,
                            //请求成功
                            success: res => {
                                if (res.code == 0) {
                                    this.isSendCode = false
                                    window.console.log('校验验证码成功', res)
                                    this.$message.success(res.msg)
                                    this.iosLogin = true
                                    this.v1WebLoginType()
                                } else {
                                    this.$message.error(res.msg)
                                }
                            },
                            //请求失败，包含具体的错误信息
                            error: error => {
                                window.console.log('error:', error)
                                this.$message.error(error.msg)
                                this.isSendCode = false
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            /**安卓登陆 */
            openDialogVisible() {
                this.dialogVisible = true
            },
            //安卓的工号、账号的确认下载
            identification() {
                let params = {
                    appId: 'Ti9f1nQ7',
                    account: this.idValue,
                    platform: 2
                }
                // eslint-disable-next-line no-undef
                $.ajax({
                    //请求方式
                    type: "POST",
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    url: this.getDownloadVersion,
                    //数据，json字符串
                    data: params,
                    //请求成功
                    success: res => {
                        window.console.log('res', res)
                        if (res.code == 0) {
                            this.andriod_href = res.data.url
                            this.download_andriod()
                            this.dialogVisible = false
                            this.idValue = ''
                        } else {
                            this.$message.error(res.msg);
                        }
                    },
                    //请求失败，包含具体的错误信息
                    error: error => {
                        window.console.log('error:', error)
                        this.$message.error(error.msg)
                    }
                });
            },
            cancel() {
                this.dialogVisible = false
                this.idValue = ''
            },
            //手机验证的确认下载
            v1WebLoginType() {
                this.downloadUrl = ''
                let params = {
                    appId: this.appIdCode,
                    isPhone: this.checks ? 0 : 1,
                    phone: this.phone_form.phone,
                    platform: this.device_type == "android" ? 2 : 1
                }
                // eslint-disable-next-line no-undef
                $.ajax({
                    //请求方式
                    type: "POST",
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    url: this.v1WebLogin,
                    //数据，json字符串
                    data: params,
                    //请求成功
                    success: res => {
                        window.console.log('res', res)
                        if (res.code == 0 && res.data.url) {
                            if (this.device_type == 'ios') {
                                this.logVisible = false;
                                // this.$message.success(res.msg);
                                this.ios_href = this.ios_href + res.data.url;
                            } else {
                                this.andriod_href = res.data.url
                                this.download_andriod()
                                this.dialogVisible = false
                                this.phone_form = {
                                    phone: '',
                                    code: ''
                                }
                            }
                            this.platform = ''
                        } else {
                            this.$message.error(res.msg)
                            this.phone_form.phone = ''
                            this.$message.error("登录失败!");
                        }
                    },
                    //请求失败，包含具体的错误信息
                    error: error => {
                        window.console.log('error:', error)
                        this.$message.error(error.msg)
                    }
                });
            },
            /**ios的登陆 */
            submitLog() {
                this.form.password = this.encryptByDES(this.form.password);
                window.console.log('this.form:', this.form)
                // eslint-disable-next-line no-undef
                $.ajax({
                    //请求方式
                    type: "POST",
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    url: this.appleVerify,
                    //数据，json字符串
                    data: this.form,
                    //请求成功
                    success: res => {
                        this.form.password = "";
                        if (res.code == 0) {
                            this.logVisible = false;
                            this.iosLogin = true
                            this.$message.success(res.msg);
                            this.ios_href = this.ios_href + res.data.url;
                        } else {
                            this.$message.error(res.msg);
                        }
                    },
                    //请求失败，包含具体的错误信息
                    error: error => {
                        window.console.log('error:', error)
                        this.form.password = "";
                        this.$message.error(error.msg);
                    }
                });
            },
            /**安卓的下载 */
            download_andriod: function () {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    // 在微信浏览器
                    this.show_weixin_notice = 1;
                } else {
                    // 下载
                    location.href = this.andriod_href;
                }
            },
            /**ios的下载 */
            download_ios: function () {
                var that = this;
                if(!this.iosLogin) {
                    this.logVisible = true
                    return
                }
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    // 在微信浏览器
                    that.show_weixin_notice = 1;
                } else {
                    // eslint-disable-next-line no-undef
                    layer.open({
                        content:
                            '<div style="text-align:center;color:red;line-height:30px;">等待安装中...</div>请等待IOS系统响应（约3~5秒）<br>并在弹出的提示框中点击“安装”<br>',
                        btn: ["已点击安装", "未弹出提示框"],
                        style: "width:100%;text-align:center",
                        yes: function () {
                            // eslint-disable-next-line no-undef
                            layer.open({
                                content:
                                    '<div style="text-align:center;color:green;line-height:30px;">TeamWork正在后台安装中...</div><div style="height:300px; overflow:scroll;"><img style="width:100%;" src="files/image/new/mobileTip.png" /></div>  <br><div id="notice" style="display:none;position:relative;height:0px;text-align:center;color:red;"><hr style="border-top: 1px;"><div id="notice_content"></div></div>',
                                btn: ["我已安装完成，点击此处"],
                                style: "width:100%",
                                yes: function () {
                                    // eslint-disable-next-line no-undef
                                    $("#notice").css("display", "block");

                                    function shake() {
                                        // var $panel = $("#" + o);
                                        // var box_left = $("#notice").width() / 2;
                                        // $panel.css({ width: "100%", position: "absolute" });
                                        // for (var i = 1; 4 >= i; i++) {
                                        //   $panel.animate({ left: -(40 - 10 * i) }, 50);
                                        //   $panel.animate({ left: +(40 - 10 * i) }, 50);
                                        // }
                                        //URL根据自己项目中实际情况而定
                                        var url = that.dlUrl.iosUrl
                                        var down = document.createElement('a');
                                        down.href = url;
                                        down.click();
                                    }

                                    shake("notice_content");
                                }
                            });
                        },
                        no: function () {
                            // eslint-disable-next-line no-undef
                            layer.open({type: 2, content: "重新请求安装", time: 2});
                            setTimeout(function () {
                                that.download_ios();
                                location.href = that.ios_href;
                            }, 1000);
                        }
                    });
                    location.href = that.ios_href;
                }
            },
            close_weixin_notice: function () {
                this.show_weixin_notice = 0;
            },
            /**获取一级官网目录 */
            getWebsiteDirectory() {
                window.console.log('this.optionsSelect', this.optionsSelect)
                let that = this
                this.$axios.get(this.websiteDirectory, {
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    params: {id: this.pId},
                }).then(res => {
                    window.console.log('一级目录res', res)
                    if (res.data.code == 0) {
                        let data = JSON.parse(JSON.stringify(res.data.data))
                        window.console.log('一级目录返回来的数据为：', JSON.stringify(data, null, 4))
                        if (data.length > 0) {
                            that.optionsSelect.push(...data)
                            let obj1 = {}
                            let peen = that.optionsSelect.reduce((cur, next) => {
                                obj1[next.id] ? "" : obj1[next.id] = true && cur.push(next);
                                return cur;
                            }, [])
                            that.optionsSelect = peen
                        } else {
                            this.getWebsiteContent()
                        }
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    // this.treeLoading = false
                })
            },
            /**官网其他目录 */
            getWebsiteMenu(node, resolve) {
                window.console.log('其他二三级目录的node', node)
                if (!node.key) {
                    return
                }
                this.treeLoading = true
                if (node.key == this.optionsSelect[2].id) {
                    window.console.log('第一次进入node.key', node.key)
                    this.treeLoading = true
                    this.treeData = []
                }
                let that = this
                this.$axios.get(this.websiteDirectory, {
                    //请求的媒体类型
                    contentType: "application/x-www-form-urlencoded",
                    params: {id: node.key},
                }).then(res => {
                    window.console.log('其他级别的目录res', res)
                    if (res.data.code == 0) {
                        let data = JSON.parse(JSON.stringify(res.data.data))
                        window.console.log('其他目录返回来的数据为：', JSON.stringify(data, null, 4))
                        if (data.length > 0) {
                            if (node.key == that.optionsSelect[2].id) {
                                that.treeData = [...data]
                            }
                            // this.treeData = [...data]
                            that.node_had = node;
                            that.resolve_had = resolve;
                            window.console.log('----------', that.treeData)
                            that.resolve_had([...data])
                        } else {
                            if (node && node.childNodes) {
                                resolve([])
                            }
                            that.mId = node.key

                            that.getWebsiteContent(data => {
                                window.console.log('data==callback:', data)
                                if (data && data.content || data && data.attachmentList) {
                                    window.console.log('jinruqita目录')
                                    if (node && node.childNodes && node.childNodes.length === 0) {
                                        this.showWebsite = true
                                        this.closeMenu = node.data.name
                                    }
                                } else {
                                    this.showWebsite = false
                                }
                            })
                        }
                        that.treeLoading = false
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    that.treeLoading = false
                })
            },
            /**一级目录的点击事件 */
            handerChange(e) {
                window.console.log('一级点击e,this.valueSelect', e, '----', this.valueSelect)
                if (this.valueSelect !== '1111') {
                    this.pId = this.valueSelect
                    this.mId = this.valueSelect
                    this.treeData = []
                    this.closeMenu = ''
                    this.nodeObj = {key: this.valueSelect}
                    this.getWebsiteMenu(this.nodeObj, this.resolve_had);
                    if (this.valueSelect == this.optionsSelect[2].id) {
                        this.showWebsite = false
                    } else {
                        this.showWebsite = true

                    }
                }
            },
            /**官网获取目录内容 */
            getWebsiteContent(callback) {
                let that = this
                that.loading = true
                // that.treeLoading = false
                this.$axios.get(this.websiteContentZip, {
                    //请求的媒体类型
                    header: {
                        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                    params: {dId: this.mId},
                }).then(res => {
                    window.console.log('res', res)
                    if (res.data.code == 0) {
                        let data = res.data.data
                        if (data) {
                            this.showWebsite = true
                            that.logVisible = false;
                            let gzip = this.unZip(data)
                            // window.console.log('目录内容',JSON.parse(gzip))
                            let pzip = JSON.parse(gzip)
                            that.dataWebsite = pzip
                            // window.console.log('content',pzip.content)
                            that.dataWebsite.content = pzip.content ? Base64.decode(pzip.content) : ''
                            that.fileData = data.attachmentList
                            // window.console.log('that.dataWebsite:',JSON.stringify(that.dataWebsite))
                            if (callback) {
                                callback(that.dataWebsite)
                            }
                        } else {
                            if (callback) {
                                // callback('')
                            }
                            this.showWebsite = false
                        }
                    } else {
                        // this.$message.error("获取目录失败!");
                    }
                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    that.loading = false

                })
            },
            // b64Data-->传入加密的数据进行解密
            unZip(key) {
                var charData = [];
                var keyArray = key.split('');
                for (var i = 0; i < keyArray.length; i++) {
                    var item = keyArray[i];
                    charData.push(item.charCodeAt(0));
                }
                var data = pako.inflate(charData);
                // 如果字符太大，会导致内存溢出报错，这里使用分片处理
                var str = '';
                var chunk = 8 * 1024
                var j;
                for (j = 0; j < data.length / chunk; j++) {
                    str += String.fromCharCode.apply(null, data.slice(j * chunk, (j + 1) * chunk));
                }
                str += String.fromCharCode.apply(null, data.slice(j * chunk));
                return decodeURIComponent(Base64.decode(str));
            },
            /*
            *** 树点击操作
             */
            elTreeClick(data, node, value, event) {
                event.stopPropagation();
                window.console.log('节点点击', data, "====s", node)
                if (node && node.childNodes && node.childNodes.length === 0 || !node.expanded) {
                    // this.closeMenu = data.name
                    // this.showWebsite = true
                    this.mId = data.id
                    this.getWebsiteContent(data1 => {
                        window.console.log('data==callback:', data1)
                        if (data1 && data1.content || data1 && data1.attachmentList) {
                            window.console.log('点击')
                            this.showWebsite = true
                            this.closeMenu = data.name
                        } else {
                            this.showWebsite = false
                        }
                    })
                    // this.getWebsiteContent()
                }
            },
            checkFileType(fileType) {
                fileType.substr(fileType.lastIndexOf('.'), fileType.length)
                let type = fileType.substr(fileType.lastIndexOf('.'), fileType.length).toLowerCase()
                window.console.log('reg', type)
                return type
            },
            showMenu() {
                this.closeMenu = ''
                this.showWebsite = false
                window.console.log('this.closeKey', this.closeKey)
            },
            showHome() {
                this.valueSelect = this.optionsSelect[0].id
            },
            openfile(url, name) {
                let that = this
                this.$axios.get(url, {
                    //请求的媒体类型
                    header: {
                        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                }).then(res => {
                    window.console.log('res:', res, name)
                    let filename
                    filename = name
                    const fileName = filename;//下载文件名称
                    const tmpDown = new Blob([res.data]);
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(tmpDown);
                    a.download = fileName;
                    a.click();

                }).catch(function (error) {
                    window.console.log(error);
                }).finally(() => {
                    that.loading = false
                })
            },
            renderContent(h,{node,data,store}){
                window.console.log('data',data)
                window.console.log('node',node)
                window.console.log('store',store)
                if(data.level == 2){
                    return(
                        <span class="custom-tree-node tree-node-3" style="display:flex;justify-content:space-between;width:100%;line-height:40px;font-size:16px;font-family: PingFangSC-Regular, PingFang SC !important;font-weight:400;">
                            <span style="width:180px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{node.label}</span>
                            <span on-click={($event)=> this.elTreeClick(data,node,store,$event )}>{(node.childNodes.length>0&&!node.expanded)?(<i  class="el-icon-arrow-right"></i>):(node.childNodes.length>0&&node.expanded)?(<i  class="el-icon-arrow-down"></i>):(<i  class="el-icon-arrow-right"></i>)}</span>
                        </span>
                    )
                }else{
                    return(
                        <span class="custom-tree-node tree-node-4" style="display:flex;justify-content:space-between;width:100%;line-height:40px;font-size:14px;font-family: PingFangSC-Regular, PingFang SC !important;font-weight:400;">
                            <span style="width:180px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{node.label}</span>
                            <span on-click={($event)=> this.elTreeClick(data,node,store,$event )}>{(node.childNodes.length>0&&!node.expanded)?(<i  class="el-icon-arrow-right"></i>):(node.childNodes.length>0&&node.expanded)?(<i  class="el-icon-arrow-down"></i>):(<i  class="el-icon-arrow-right"></i>)}</span>
                        </span>
                    )
                }
            },
        }
    };
</script>
<style lang="scss" scoped>
    .btn_font {
        color: #00B6FF;
        padding: 10px 0 20px;
    }

    /deep/ .el-dialog__body {
        padding: 7px 25px 0px !important;
    }

    /deep/ .el-dialog__footer {
        border-top: 1px solid #e8e8e8;
        padding: 5px 0;
    }

    .dialog-footer {
        display: flex;
        align-items: center;

        .el-button {
            min-width: 150px;
            font-size: 15px;
        }

        .cancel-btn {
            background-color: transparent;
            border: none;
            color: #616161;
        }

        .color-btn {
            background-color: transparent;
            border: none;
            color: #00B6FF;
        }

        .only-one {
            width: 100%;
        }
    }

    .dialog_code {
        width: 260px;
        margin: 10px auto 5px;
        // margin: 10px auto;
        img {
            display: inline-block;
            width: 16px !important;
            height: 16px !important;
        }

        /deep/ .oa_num, .phone_word, .code_word {
            box-shadow: 0px 0px 8px 0px rgba(25, 54, 90, 0.02), 0px 4px 5px 0px rgba(25, 54, 90, 0.04);
            border-radius: 16px;
            border: 1px solid rgba(240, 240, 240, 1);
            padding: 0 10px;

            input {
                background: transparent;
            }

            /deep/ .el-input__suffix {
                margin-right: 7px;
                margin-top: -1px;

                .el-input__icon:before {
                    font-size: 13px;
                }
            }
        }

        .oa_num {
            position: relative;

        }

        /deep/ ::-webkit-input-placeholder {
            font-size: 14px;
            color: #999999;
        }

        .code_word {
            background: transparent;
            user-select: none;
            font-size: 16px;
            color: #666666;
            width: 100%;
            outline: none;
            position: relative;
            z-index: 1;

            /deep/ .el-input__suffix {
                margin-right: 30px;
            }

            &::-webkit-input-placeholder {
                color: #BFBFBF;
            }
        }

        .code_btn {
            position: absolute;
            right: 10px;
            z-index: 1;
        }

        .code_btn1 {
            position: absolute;
            right: 1px;
            z-index: 1;
            color: #CCCCCC;
            border: 0px;
            background: #F5F8FA;
            padding-left: 0;
            padding-right: 0;
        }

        /deep/ .el-form-item {
            margin-bottom: 20px;
        }

        // /deep/.el-form-item__content{
        //   margin-left:0 !important;
        // }
        /deep/ .el-input__inner {
            border: 0;
            border-radius: 0;
            // border-bottom: 1px solid #d9d9d9;
            font-size: 16px;
            color: #666666;
            padding-left: 0px;
            // height: 26px;
            /deep/ &::-webkit-input-placeholder {
                color: #BFBFBF;
            }
        }

        /deep/ .el-input {
            width: 100% !important;
        }

        /deep/ .el-input__prefix {
            left: 0;
        }

        /deep/ .el-input--prefix {
            .el-input__inner {
                padding-left: 37px;
            }
        }

        /deep/ .el-input__suffix {
            right: -4px;
        }
    }
</style>
<style lang="scss" scoped>
    body, html, div, dl, dt, dd, form, h1, h2, h3, h4, h5, h6, img, ol, ul, li, table, th, td, p, span, a, code {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        word-break: break-word;
        width: 100%;
        font-family: PingFangSC-Regular, PingFang SC !important;
    }

    html {
        position: relative;
        height: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    body {
        width: 100%;
        max-width: 640px;
        height: 100%;
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-size: 1rem;
        color: #666;
        background: white;
        position: absolute;
        top: 0;
        left: 0;
    }

    div, dl, dt, dd, form, h1, h2, h3, h4, h5, h6, img, ol, ul, li, table, th, td, p, span, a, code {
        font-family: PingFangSC-Regular, PingFang SC !important;
    }


    ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ccc;
    }

    :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ccc;
    }

    ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ccc;
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ccc;
    }

    a {
        color: #2bb3fe;
    }

    .download-btn {
        float: left;
        height: 60px;
        width: 50%;
        text-align: center;
        font-size: 1rem;
        line-height: 44px;
        vertical-align: middle;
        cursor: pointer;
    }

    .download-btn .item {
        margin: 0 auto;
        margin-top: 8px;
        color: #fff;
        width: 144px;
        background: linear-gradient(90deg, #07D5FC 0%, #20A4FE 100%);
        box-shadow: 0px 0px 12px 0px rgba(25, 54, 90, 0.02), 0px 6px 8px 0px rgba(25, 54, 90, 0.04);
        border-radius: 40px;
        border: 1px solid #F0F0F0;
    }

    .download-btn .item:active {
        background: #2bb3fe;
        color: white;
    }

    .dialog {
        /deep/ .el-select,
        /deep/ .el-input,
        /deep/ .el-input__inner {
            border: 0px;
            background-color: #F5F8FA;
            color: #000;
            border: 0px;
            border-radius: 0px;
            text-align: left;
        }

    }

    .main {
        background: #F5F8FA;

        .header {
            position: absolute;
            top: 0;
            width: 100%;
            align-items: center;
            display: flex;
            height: 11%;

            img {
                display: inline-block;
                width: 74px;
                height: 36px;
                margin-left: 20px;
            }

            /deep/ .select {
                display: inline-block;
                font-size: 14px;
                margin-right: 10px;
                width: 170px;
                background: #F5F8FA;

                /deep/ .el-select,
                /deep/ .el-input,
                /deep/ .el-input__inner {
                    border: 0px;
                    background-color: #F5F8FA !important;
                    color: #000;
                    border: 0px;
                    border-radius: 0px;
                    text-align: right;
                }

            }
        }

        .contain {
            display: inline-block;
            width: 100%;
            height: 89%;

            img {
                display: inline-block;
                width: 300px;
                height: 300px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

        }

        .contain-second {
            display: inline-block;
            width: 100%;
            height: 89%;
            box-sizing: border-box;
            -moz-box-sizing: border-box; /* Firefox */
            -webkit-box-sizing: border-box; /* Safari */
            background-color: #fff;
            -webkit-overflow-scrolling: touch;
            position: absolute;
            top: 11%;
            bottom: 0;

            .no-data {
                height: 100%;
                padding: 16px 16px;
                margin: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                img {
                    width: 320px;
                    height: 164px;
                }

                span {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC !important;
                    font-weight: 400;
                    color: #CBCBCB;
                    line-height: 20px;
                    text-align: center;
                }
            }

            .contain-second-item {
                height: 100%;
                padding: 16px;
                width: 100%;
                -webkit-overflow-scrolling: touch;

                .content {
                    display: inline-block;
                    overflow: hidden;
                    letter-spacing: 1px;
                    word-break: break-all;
                    overflow-wrap: break-word;

                    /deep/ p {
                        width: 100% !important;
                        word-break: break-word !important;
                        font-family: PingFangSC-Regular, PingFang SC !important;
                    }

                    /deep/ span {
                        width: 100% !important;
                        word-break: break-word !important;
                        font-family: PingFangSC-Regular, PingFang SC !important;
                    }

                    /deep/ table {
                        width: 100% !important;
                        word-break: break-word !important;
                    }

                    /deep/ .MsoNormal {
                        width: 100% !important;
                        word-break: break-word;

                        span {
                            width: 100% !important;
                            word-break: break-word !important;
                            white-space: pre-line !important;
                            font-family: PingFangSC-Regular, PingFang SC !important;
                        }
                    }

                    /deep/ .MsoTableGrid {
                        width: 100% !important;
                        word-break: break-word;
                    }

                    /deep/ .syntaxhighlighter {
                        width: 100% !important;
                        word-break: break-word;
                    }

                }

                p {
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC !important;
                    font-weight: 400;
                    color: #A0A0A0;
                    line-height: 20px;
                    letter-spacing: 1px;
                    margin-top: 16px;
                    margin-bottom: 8px;

                }

                .comm-file-logo-box {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;

                    .comm-file-logo {
                        margin-left: 16px;
                        margin-top: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        .aimg {
                            width: 104px;
                            height: 104px;
                            border-radius: 6px;
                            border: 1px solid #CBCBCB;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;

                            span {
                                display: inline-block;
                                width: 84px;
                                margin-left: 5px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            img {
                                width: 32px;
                                height: 32px;
                                cursor: pointer;
                            }
                        }

                        img {
                            width: 104px;
                            height: 104px;
                            border-radius: 6px;
                            border: 1px solid #CBCBCB;
                            cursor: pointer;
                        }

                        span {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }
            }

        }

        .menu_show {
            box-sizing: border-box;
            -moz-box-sizing: border-box; /* Firefox */
            -webkit-box-sizing: border-box; /* Safari */
            position: absolute;
            top: 18%;
            bottom: 0;
            height: 82%;
        }

        .menu-second {
            display: inline-block;
            width: 100%;
            background-color: #fff;
            height: 89%;
            position: absolute;
            top: 11%;
            bottom: 0;
            -webkit-overflow-scrolling: touch;

            /deep/ .tree {
                height: 100%;
                padding: 16px;
                width: 100%;
            }
        }

        .menu-child {
            position: absolute;
            top: 11%;
            bottom: 0;
            display: inline-block;
            width: 100%;
            height: 7%;
            box-sizing: border-box;
            -moz-box-sizing: border-box; /* Firefox */
            -webkit-box-sizing: border-box; /* Safari */
            background: #fff;
            padding: 0 22px 0 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC !important;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            img {
                display: inline-block;
                width: 20px;
                height: 20px;
                text-align: right;
                // padding-left: 40px;
            }

            border-bottom: 1px solid #EBEBEB;
        }
    }

    /deep/ .el-select,
    /deep/ .el-input,
    /deep/ .el-input__inner {
        border: 0px;
        background-color: #F5F8FA;
        color: #000;
        border: 0px;
        border-radius: 0px;
        text-align: right;
    }
</style>
<style>
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition-delay: 999999s;
        transition: color 99999s ease-out, background-color 99999s ease-out;
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
    }

    .el-dialog {
        border-radius: 14px;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
    }

    .el-dialog__title {
        width: 238px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-weight: 600;
        color: #383838;
        line-height: 22px;
    }

    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 0px;
    }

    .el-dialog__body h3 {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-weight: 400;
        color: #383838;
        line-height: 22px;
        padding-bottom: 5px;
        text-align: center;
    }

    .el-form-item {
        margin-bottom: 6px;
        margin-top: 6px;
    }

    img {
        width: 100%;
    }

    .el-collapse {
        border-top: 0px;
        border-bottom: 0px;
        padding: 16px;
    }

    .el-collapse-item__header {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-weight: 400;
        color: #333333;
    }

    .el-tree {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC !important;
        font-weight: 400;
        color: #333333;
    }

    .el-tree-node__content {
        height: 48px;
    }

    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #fff;
    }

    .tree .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    .el-tree-node__expand-icon {
        display: none;
    }

    .tree .el-icon-caret-right:before {
        content: "\E602";
        font-size: 18px;
    }

    .tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
        content: "\E63c";
        font-size: 18px;
    }

    .el-tree-node:focus > .el-tree-node__content {
        background-color: #fff !important;
        color: #00B6FF;
    }

    a {
        text-decoration: none;
    }

    .el-select-dropdown__item {
        padding: 0 20px !important;
    }
</style>
